import { createContext, useContext, useState } from 'react';

const translations = {
  fr: {
    // Login
    login_title: "Connexion",
    login_subtitle: "Accedez a votre espace personnel",
    login_username: "Identifiant",
    login_username_placeholder: "Nom d'utilisateur",
    login_password: "Mot de passe",
    login_password_placeholder: "Mot de passe",
    login_submit: "Se connecter",
    login_connecting: "Connexion...",
    login_seed: "Initialiser les donnees demo",
    login_seeding: "Initialisation...",
    login_hero_title: "Crypto Pool\nManagement",
    login_hero_desc: "Plateforme de suivi de performance de votre portefeuille crypto. Consultez vos rendements, transactions et allocations en temps reel.",
    login_powered: "Powered by",
    login_invalid: "Identifiants invalides",
    login_no_client: "Aucun profil client lie a ce compte. Contactez votre administrateur.",
    login_welcome: "Bienvenue",

    // Admin Dashboard
    admin_badge: "Admin",
    admin_clients: "Clients",
    admin_total_deposits: "Total Depots",
    admin_total_balance: "Total Balance",
    admin_total_return: "Total Rendement",
    admin_new_client: "Nouveau Client",
    admin_user: "Utilisateur",
    admin_users: "Utilisateurs",
    admin_view_report: "Voir le rapport",
    admin_edit: "Modifier",
    admin_delete: "Supprimer",
    admin_no_clients: "Aucun client. Cliquez sur \"Nouveau Client\" pour commencer.",
    admin_client_name: "Nom du client",
    admin_initial_deposit: "Depot initial ($)",
    admin_join_date: "Date d'inscription (DD/MM/YYYY)",
    admin_cancel: "Annuler",
    admin_create: "Creer",
    admin_new_user: "Nouvel Utilisateur",
    admin_username: "Nom d'utilisateur",
    admin_password: "Mot de passe",
    admin_role: "Role",
    admin_linked_client: "Client lie",
    admin_select: "Selectionner...",
    admin_confirm_delete: "Supprimer ce client ?",
    admin_client_created: "Client cree",
    admin_client_deleted: "Client supprime",
    admin_user_created: "Utilisateur cree",
    admin_load_error: "Erreur de chargement",
    admin_change_password: "Mot de passe",
    admin_new_password: "Nouveau mot de passe",
    admin_password_changed: "Mot de passe modifie",
    admin_deposit: "Depot",
    admin_balance: "Balance",
    admin_return: "Rendement",
    admin_cumul_pct: "% Cumule",
    admin_monthly_pct: "% Mensuel",
    admin_member_since: "Membre depuis",
    admin_actions: "Actions",

    // Admin Client Edit
    edit_back: "Retour",
    edit_edition: "Edition",
    edit_view_report: "Voir rapport",
    edit_save: "Sauvegarder",
    edit_saving: "Sauvegarde...",
    edit_tab_info: "Informations",
    edit_tab_transactions: "Transactions",
    edit_tab_allocations: "Allocations",
    edit_client_info: "Informations Client",
    edit_client_name: "Nom du client",
    edit_account_type: "Type de compte",
    edit_date_joined: "Date d'inscription",
    edit_performance: "Performance",
    edit_deposit: "Depot ($)",
    edit_balance: "Balance ($)",
    edit_balance_date: "Date balance",
    edit_return_amount: "Rendement ($)",
    edit_cumul_pct: "% Cumule",
    edit_monthly_pct: "% Mensuel",
    edit_new_balance: "Nouveau Solde ($)",
    edit_new_balance_date: "Date nouveau solde",
    edit_tx_history: "Historique des Transactions",
    edit_add: "Ajouter",
    edit_type: "Type",
    edit_date: "Date",
    edit_amount: "Montant",
    edit_note: "Note",
    edit_new_tx: "Nouvelle Transaction",
    edit_edit_tx: "Modifier Transaction",
    edit_tx_withdrawal: "Retrait",
    edit_tx_deposit: "Depot",
    edit_confirm_delete_tx: "Supprimer cette transaction ?",
    edit_tx_added: "Transaction ajoutee",
    edit_tx_updated: "Transaction modifiee",
    edit_tx_deleted: "Transaction supprimee",
    edit_client_updated: "Client mis a jour",
    edit_save_error: "Erreur de sauvegarde",
    edit_not_found: "Client non trouve",
    edit_allocations: "Allocations du Portefeuille",
    edit_alloc_placeholder: "Nom (ex: Crypto Runner)",
    edit_no_alloc: "Aucune allocation. Cliquez sur \"Ajouter\" pour definir les allocations.",
    edit_total: "Total",

    // Client Report
    report_title: "Crypto Pool Update",
    report_member_since: "Membre depuis le",
    report_last_update: "Derniere mise a jour",
    report_total_deposit: "Depot Total",
    report_balance: "Balance Fin de Mois",
    report_return: "Rendement",
    report_monthly: "% Mensuel",
    report_monthly_sub: "ce mois",
    report_cumul: "cumule",
    report_new_balance: "Nouveau Solde",
    report_allocation: "Allocation du Portefeuille",
    report_no_alloc: "Aucune allocation definie",
    report_summary: "Resume du Compte",
    report_account_type: "Type de compte",
    report_tx_count: "Nombre de transactions",
    report_total_deposits: "Total depots",
    report_total_withdrawals: "Total retraits",
    report_perf_cumul: "Performance cumulee",
    report_perf_monthly: "Performance mensuelle",
    report_tx_history: "Historique des Transactions",
    report_date: "Date",
    report_type: "Type",
    report_amount: "Montant",
    report_deposit: "Depot",
    report_withdrawal: "Retrait",
    report_not_found: "Rapport non trouve",
    report_loading: "Chargement du rapport...",
    report_loading_short: "Chargement...",
    report_pdf_generating: "Generation du PDF en cours...",
    report_pdf_success: "PDF telecharge !",
    report_pdf_error: "Erreur lors de la generation du PDF",
    report_at: "au",

    // Common
    common_error: "Erreur",
    common_loading: "Chargement...",
  },
  en: {
    // Login
    login_title: "Login",
    login_subtitle: "Access your personal space",
    login_username: "Username",
    login_username_placeholder: "Username",
    login_password: "Password",
    login_password_placeholder: "Password",
    login_submit: "Sign in",
    login_connecting: "Signing in...",
    login_seed: "Initialize demo data",
    login_seeding: "Initializing...",
    login_hero_title: "Crypto Pool\nManagement",
    login_hero_desc: "Portfolio performance tracking platform. View your returns, transactions and allocations in real time.",
    login_powered: "Powered by",
    login_invalid: "Invalid credentials",
    login_no_client: "No client profile linked to this account. Contact your administrator.",
    login_welcome: "Welcome",

    // Admin Dashboard
    admin_badge: "Admin",
    admin_clients: "Clients",
    admin_total_deposits: "Total Deposits",
    admin_total_balance: "Total Balance",
    admin_total_return: "Total Return",
    admin_new_client: "New Client",
    admin_user: "User",
    admin_users: "Users",
    admin_view_report: "View report",
    admin_edit: "Edit",
    admin_delete: "Delete",
    admin_no_clients: "No clients yet. Click \"New Client\" to get started.",
    admin_client_name: "Client name",
    admin_initial_deposit: "Initial deposit ($)",
    admin_join_date: "Join date (DD/MM/YYYY)",
    admin_cancel: "Cancel",
    admin_create: "Create",
    admin_new_user: "New User",
    admin_username: "Username",
    admin_password: "Password",
    admin_role: "Role",
    admin_linked_client: "Linked client",
    admin_select: "Select...",
    admin_confirm_delete: "Delete this client?",
    admin_client_created: "Client created",
    admin_client_deleted: "Client deleted",
    admin_user_created: "User created",
    admin_load_error: "Loading error",
    admin_change_password: "Password",
    admin_new_password: "New password",
    admin_password_changed: "Password changed",
    admin_deposit: "Deposit",
    admin_balance: "Balance",
    admin_return: "Return",
    admin_cumul_pct: "% Cumul.",
    admin_monthly_pct: "% Monthly",
    admin_member_since: "Member since",
    admin_actions: "Actions",

    // Admin Client Edit
    edit_back: "Back",
    edit_edition: "Editing",
    edit_view_report: "View report",
    edit_save: "Save",
    edit_saving: "Saving...",
    edit_tab_info: "Information",
    edit_tab_transactions: "Transactions",
    edit_tab_allocations: "Allocations",
    edit_client_info: "Client Information",
    edit_client_name: "Client name",
    edit_account_type: "Account type",
    edit_date_joined: "Join date",
    edit_performance: "Performance",
    edit_deposit: "Deposit ($)",
    edit_balance: "Balance ($)",
    edit_balance_date: "Balance date",
    edit_return_amount: "Return ($)",
    edit_cumul_pct: "% Cumulative",
    edit_monthly_pct: "% Monthly",
    edit_new_balance: "New Balance ($)",
    edit_new_balance_date: "New balance date",
    edit_tx_history: "Transaction History",
    edit_add: "Add",
    edit_type: "Type",
    edit_date: "Date",
    edit_amount: "Amount",
    edit_note: "Note",
    edit_new_tx: "New Transaction",
    edit_edit_tx: "Edit Transaction",
    edit_tx_withdrawal: "Withdrawal",
    edit_tx_deposit: "Deposit",
    edit_confirm_delete_tx: "Delete this transaction?",
    edit_tx_added: "Transaction added",
    edit_tx_updated: "Transaction updated",
    edit_tx_deleted: "Transaction deleted",
    edit_client_updated: "Client updated",
    edit_save_error: "Save error",
    edit_not_found: "Client not found",
    edit_allocations: "Portfolio Allocations",
    edit_alloc_placeholder: "Name (e.g. Crypto Runner)",
    edit_no_alloc: "No allocations. Click \"Add\" to define allocations.",
    edit_total: "Total",

    // Client Report
    report_title: "Crypto Pool Update",
    report_member_since: "Member since",
    report_last_update: "Last update",
    report_total_deposit: "Total Deposit",
    report_balance: "End of Month Balance",
    report_return: "Return",
    report_monthly: "% Monthly",
    report_monthly_sub: "this month",
    report_cumul: "cumul.",
    report_new_balance: "New Balance",
    report_allocation: "Portfolio Allocation",
    report_no_alloc: "No allocation defined",
    report_summary: "Account Summary",
    report_account_type: "Account type",
    report_tx_count: "Number of transactions",
    report_total_deposits: "Total deposits",
    report_total_withdrawals: "Total withdrawals",
    report_perf_cumul: "Cumulative performance",
    report_perf_monthly: "Monthly performance",
    report_tx_history: "Transaction History",
    report_date: "Date",
    report_type: "Type",
    report_amount: "Amount",
    report_deposit: "Deposit",
    report_withdrawal: "Withdrawal",
    report_not_found: "Report not found",
    report_loading: "Loading report...",
    report_loading_short: "Loading...",
    report_pdf_generating: "Generating PDF...",
    report_pdf_success: "PDF downloaded!",
    report_pdf_error: "Error generating PDF",
    report_at: "as of",

    // Common
    common_error: "Error",
    common_loading: "Loading...",
  }
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'fr');

  const toggleLang = () => {
    const next = lang === 'fr' ? 'en' : 'fr';
    localStorage.setItem('lang', next);
    setLang(next);
  };

  const t = (key) => translations[lang]?.[key] || translations['fr']?.[key] || key;

  return (
    <I18nContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
